import { faToggleLargeOff, faToggleLargeOn } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '@karnov/kui-react'

import { useTranslation } from 'react-i18next'

import { useFeatureFlag } from 'hooks/useFeatureFlag'
import { useInlineReferenceValidationToggleStore } from 'stores/useInlineReferenceValidationToggleStore'

export const InlineReferenceValidationToggle = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'conversation.references_panel.source_validation',
  })

  const { inlineReferenceValidationType, setInlineReferenceValidationType } = useInlineReferenceValidationToggleStore()
  const hasSourceValidationFeatureFlag = useFeatureFlag('source_validation')

  if (!hasSourceValidationFeatureFlag) return null

  return (
    <>
      <Button
        onClick={() => setInlineReferenceValidationType(inlineReferenceValidationType === 'type' ? null : 'type')}
        variant="plain"
        isSmall
        isOnKarnovNote
      >
        <FontAwesomeIcon className="mr-2" icon={inlineReferenceValidationType === 'type' ? faToggleLargeOn : faToggleLargeOff} />
        {`${t('button')} ${t('toggle_type')}`}
      </Button>
      <Button
        onClick={() => setInlineReferenceValidationType(inlineReferenceValidationType === 'name' ? null : 'name')}
        variant="plain"
        isSmall
        isOnKarnovNote
      >
        <FontAwesomeIcon className="mr-2" icon={inlineReferenceValidationType === 'name' ? faToggleLargeOn : faToggleLargeOff} />
        {`${t('button')} ${t('toggle_name')}`}
      </Button>
    </>
  )
}
